module.exports = __webpack_public_path__ + "img/make-your-meal.12ac476c.png";